import React from 'react';

/**
 * Wraps text with a tag with class name
 * @param {string} className Class name to be used by tag
 * @param {string} Tag=span Tag to use
 * @returns {node} Node tag with class name
 */
export const wrapTextWithTagFormatter = (className, Tag = 'span') => {
    const TextWithTag = (text) => <Tag className={className}>{text}</Tag>;

    return TextWithTag;
};
